import { find, isEmpty } from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';

import Selector, { StyledMultiValue } from '../../Common/Selector';
import TicketType, { ITicketType, StyledType } from '../TicketType';

import { Remove as RemoveIcon } from '@icons/tagsselect';
import { ValueOf } from '@utils/tsUtils';
import { TICKET_TYPES } from '../../../../constants';

const { CLASS_NAME_PREFIX, StyledRemove } = Selector;

export interface TypeType {
  label: string;
  value: string;
  subtype: string;
  type: ValueOf<typeof TICKET_TYPES>;
}

type ValueType = {
  type: string;
  subtype: string;
};

export interface TicketFilterByTypeProps {
  className?: string;
  name: string;
  onChange: (event: CustomEvent) => void;
  types: TypeType[];
  value: ValueType[] | null;
}

const PLACEHOLDER = 'Все тикеты';

const StyledFilter = styled(Selector)`
  border: 1px solid #e6e9ee;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 0 3px;

  ${StyledMultiValue} {
    margin: 2px 2px;
  }

  .${CLASS_NAME_PREFIX}__multi-value {
    border: none;
  }

  .${CLASS_NAME_PREFIX}__multi-value__label {
    padding: 0;
  }
`;

const StyledMultiValueRemove = styled(StyledRemove)`
  padding-left: 0 !important;
`;

const StyledTicketType = styled(TicketType)`
  width: fit-content;
`;

const StyledMultiValueTicketType = styled(TicketType)`
  ${StyledType} {
    padding-right: 0;
  }
`;

const TicketTypeMultiValueRemove = props => (
  <StyledMultiValueRemove {...props}>
    <RemoveIcon />
  </StyledMultiValueRemove>
);

class TicketFilterByType extends React.PureComponent<TicketFilterByTypeProps> {
  el: any = null;

  static defaultProps = {
    className: '',
    name: '',
    types: null,
    value: null,
  };
  static renderMultiValue({ data, ...innerProps }) {
    const { subtype, type } = data;

    return (
      <div {...innerProps}>
        <StyledMultiValueTicketType
          subtype={subtype}
          type={type}
          suffix={<TicketTypeMultiValueRemove {...innerProps.removeProps} />}
        />
      </div>
    );
  }

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleRef = this.handleRef.bind(this);
  }

  handleChange(value) {
    const { name, onChange } = this.props;

    const formatedValue = Array.isArray(value)
      ? value.map(v => ({
          type: v.type,
          subtype: v.subtype,
        }))
      : null;

    if (this.el) {
      this.el.name = name;
      this.el.value = formatedValue;

      const event = new CustomEvent('change', { bubbles: true });

      this.el.dispatchEvent(event);
      onChange(event);
    }
  }

  handleRef(ref) {
    this.el = ReactDOM.findDOMNode(ref);
  }

  render() {
    const { types, value, ...props } = this.props;

    if (isEmpty(types)) {
      return null;
    }

    let formatedValue: (TypeType | undefined)[] | null = null;
    if (Array.isArray(value)) {
      formatedValue = value.map(v =>
        find(types, { type: v.type, subtype: v.subtype })
      );
    }

    return (
      <StyledFilter
        {...props}
        components={{
          MultiValue: TicketFilterByType.renderMultiValue,
        }}
        isMulti
        isSearchable
        onChange={this.handleChange}
        options={types}
        placeholder={PLACEHOLDER}
        ref={this.handleRef}
        value={formatedValue}
        closeMenuOnSelect={false}
        blurInputOnSelect={false}
      >
        {({ data }) => {
          const { subtype, type } = data;

          return <StyledTicketType subtype={subtype} type={type} />;
        }}
      </StyledFilter>
    );
  }
}

export default TicketFilterByType;
